import React, { Component } from 'react'
import Breadcumb from '../../components/Breadcumb/Breadcumb'
const BreadcrumbData = [
    {
        id:1,
        page_title:"Dashboard",
        page_path:"/",
        icon:"ews ewse_gaphicsdes",
    },
    {
        id:2,
        page_title:"404 ( Page not found )",
        page_path:"/not-found",
        icon:"ews ewse_gaphicsdes",
    }
]
export default class NotFound extends Component {
    render() {
        return (
            <>
                <Breadcumb items={BreadcrumbData}/>
                <div className="page-wrapper pd20">
                    <h1>404</h1>
                    <p>Sorry, the page you were trying to view does not exist.</p>
                </div>
            </>

        )
    }
}
